import { OrderPriceNegotiationStatus } from "@/biz/order";
import i18n from "@/i18n";

// 此处顺序会影响某些地方 过滤条件显示的顺序 如：collaboration-influencer-第一个过滤框
export enum AdsOrderStatus {
  CollaborationEstablished = "Collaboration_established",
  PendingProductionKickoff = "Pending_production_kickoff", // 非寄样-待确认
  PendingCreatorAddress = "Pending_creator_address", // 待达人填写地址
  PendingProductShipment = "Pending_Product_shipment", // 待发货
  PendingProductArrival = "Pending_Product_Arrival", // 发货中
  UnderScriptProduction = "Under_script_production",
  UnderScriptReview = "Under_script_review",
  UnderContentProduction = "Under_content_production",
  UnderContentReview = "Under_content_review",
  AdsPendingPublish = "Ads_pending_publish",
  AdsPublished = "Ads_published",
  CollaborationCancelled = "Collaboration_cancelled",
  CollaborationWithdrawn = "Collaboration_withdrawn",
  Expired = "Expired", // 广告主15天无反馈，自动取消
  PendingCreatorAccountInfo = "Pending_creator_account_info", // 广告主通过，待达人填写账号信
  PendingAccountSetup = "Pending_account_setup", // 待广告主给达人设置账号
  // 下面两个状态是内部达人池匹配阶段
  PendingSelection = "Pending_selection",
  QuoteRequested = "Quote_requested",
}

export const getAdsOrderStatusLabel = (status: AdsOrderStatus, data: any, t: any) => {
  switch (status) {
    case AdsOrderStatus.PendingSelection:
      return t("components.orderStatusComponent.pendingSelection", { defaultValue: "Pending your selection" });
    case AdsOrderStatus.QuoteRequested:
      return !!data?.ahaPicksOffer
        ? t("components.orderStatusComponent.awaitingInfluencerReply", {
            defaultValue: "Awaiting influencer's reply",
          })
        : t("components.orderStatusComponent.quoteRequested", {
            defaultValue: "Awaiting influencer's quote",
          });
    case AdsOrderStatus.CollaborationEstablished:
      // 达人首次报价待广告主审核
      if (data?.priceNegotiationStatus === OrderPriceNegotiationStatus.UnderAdsFirstReview) {
        return t("components.orderStatusComponent.firstRateUnderAdvertiserReview", {
          defaultValue: "Influencer first rate under review",
        });
      }
      // 达人出价待广告主确认
      if (data?.priceNegotiationStatus === OrderPriceNegotiationStatus.UnderAdsReview) {
        return t("components.orderStatusComponent.counterOfferUnderAdvertiserReview", { defaultValue: "Influencer rate under review" });
      }
      // 广告主出价待达人确认
      if (data?.priceNegotiationStatus === OrderPriceNegotiationStatus.UnderCreatorReview) {
        return t("components.orderStatusComponent.priceProposalUnderInfluencerReview", { defaultValue: "Offer under influencer review" });
      }
      // 达人确认价格
      if (data?.priceNegotiationStatus === OrderPriceNegotiationStatus.PendingAdsApproval) {
        return t("components.orderStatusComponent.pendingPayment", { defaultValue: "Ready to pay" });
      }
      return t("components.orderStatusComponent.collaborationEstablished", { defaultValue: "New candidate" });
    case AdsOrderStatus.PendingProductionKickoff:
      return t("components.orderStatusComponent.pendingProductionKickoff", { defaultValue: "Pending production kickoff" });
    case AdsOrderStatus.PendingCreatorAddress:
      return t("components.orderStatusComponent.pendingCreatorAddress", { defaultValue: "Pending creator address" });
    case AdsOrderStatus.UnderScriptProduction:
      return t("components.orderStatusComponent.underScriptProduction", { defaultValue: "Under script production" });
    case AdsOrderStatus.UnderScriptReview:
      return t("components.orderStatusComponent.underScriptReview", { defaultValue: "Under script review" });
    case AdsOrderStatus.UnderContentProduction:
      return t("components.orderStatusComponent.underContentProduction", { defaultValue: "Under content production" });
    case AdsOrderStatus.UnderContentReview:
      return t("components.orderStatusComponent.underContentReview", { defaultValue: "Under content review" });
    case AdsOrderStatus.AdsPendingPublish:
      return t("components.orderStatusComponent.adsPendingPublish", { defaultValue: "Ads pending publish" });
    case AdsOrderStatus.AdsPublished:
      return t("components.orderStatusComponent.adsPublished", { defaultValue: "Ads published" });
    case AdsOrderStatus.CollaborationCancelled:
      return t("components.orderStatusComponent.collaborationCancelled", { defaultValue: "Collaboration cancelled" });
    case AdsOrderStatus.PendingProductShipment:
      return t("components.orderStatusComponent.pendingProductShipment", { defaultValue: "Pending product shipment" });
    case AdsOrderStatus.PendingProductArrival:
      return t("components.orderStatusComponent.pendingProductArrival", { defaultValue: "Pending product arrival" });
    case AdsOrderStatus.CollaborationWithdrawn:
      return t("components.orderStatusComponent.collaborationWithdrawn", { defaultValue: "Collaboration withdrawn" });
    case AdsOrderStatus.Expired:
      return t("components.orderStatusComponent.expired", { defaultValue: "Expired" });
    case AdsOrderStatus.PendingCreatorAccountInfo:
      return t("components.orderStatusComponent.pendingCreatorAccountInfo", {
        defaultValue: "Awaiting influencer access information",
      });
    case AdsOrderStatus.PendingAccountSetup:
      return t("components.orderStatusComponent.pendingAccountSetup", {
        defaultValue: "Pending brand setup",
      });
    default:
      return String(status);
  }
};

export enum AdsPlatform {
  Youtube = "youtube",
  TikTok = "tiktok",
  Instagram = "instagram",
  Facebook = "facebook",
  LinkedIn = "linkedin",
  X = "x",
  Twitter = "twitter",
}

export enum leadsStatus {
  Created = "Created",
  Paid = "Paid",
  Converted = "Converted",
  Forwarded = "Forwarded",
}

// 延期申请状态 PostponeStatus
export enum PostponeStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
}

// 订单取消类型
export enum OrderCancelType {
  // 广告主能看到的
  /** 广告主拒绝申请 */
  ApplyRejected = "Apply_rejected",
  /** 内容被拒绝 */
  DraftRejected = "Draft_rejected",
  /** 广告主充值失败 */
  ChargeFailed = "Charge_failed",
  /** 达人逾期 */
  CreatorOverdue = "Overdue",
  /** 达人未开始制作 */
  CreatorNotStart = "Creator_not_start",
  /** 达人撤回申请 */
  CreatorWithdraw = "Creator_withdraw",
  /** 申请过期 */
  ApplyExpired = "Apply_expired",
  /** 寄样地区不符合 */
  InvalidShipmentLocation = "Invalid_shipment_location",

  // 广告主看不到的
  /** 达人拒绝 */
  CreatorRejected = "Creator_rejected",
  /** 申请已满 */
  NoQuota = "No_quota",
  /** Cpm超过限制 */
  CpmLimit = "Cpm_limit",
  /** 受众校验不通过或造假 */
  ValidateCancelled = "Validate_cancelled",
  /** 运营取消 */
  OpsCancelled = "Ops_cancelled",
  /** 其他 */
  Others = "Others",
}


// linkedin 的两种类型   达人端有相同的枚举 要改一块改
export enum LinkedInContentType {
  POST = 'Post', // 一开始用的类型，后来细分成下面的类型，用来兼容老数据
  IMAGE_TEXT = 'Image & Text',
  VIDEO = 'Video'
}
// linkedin 的两种类型对应的标签  达人端有相同的枚举 要改一块改
export const LinkedInContentTypeLabel = {
  [LinkedInContentType.POST]: 'LinkedIn post', // 兼容旧数据
  [LinkedInContentType.IMAGE_TEXT]: 'LinkedIn image posts',
  [LinkedInContentType.VIDEO]: 'LinkedIn video posts'
};

// 每种类型订单对应的描述   达人端有相同的枚举 要改一块改
export const getPlatformVideoContentType = ({
  platform,
  contentType
}: {
  platform: string;
  contentType?: string;
}) => {
  if (contentType === 'Dedicated video' || contentType === 'Integrated video') {
    return contentType;
  }
  if (
    contentType === 'Post' &&
    AdsPlatform.Instagram.toLowerCase() === platform
  ) {
    return 'Carousel post';
  }
  if (AdsPlatform.Youtube.toLowerCase() === platform)
    return 'Dedicated video';
  if (AdsPlatform.TikTok.toLowerCase() === platform) return 'Tiktok video';
  if (AdsPlatform.Instagram.toLowerCase() === platform) return 'Reels';
  if (AdsPlatform.Twitter.toLowerCase() === platform) return 'Post';
  if (AdsPlatform.LinkedIn.toLowerCase() === platform) {
    return (
      LinkedInContentTypeLabel[contentType as LinkedInContentType] || 'Post'
    );
  }
  return contentType || 'Post';
};

// 达人端有相同的 要改一块改
export const getPlatformVideoContentTypeDesc = (
  key: string,
  platform?: string
) => {
  const map: any = {
    'Dedicated video': i18n.t('orderDetail.orderTypeDescription.dedicatedVideo', {
      defaultValue:
        'A standalone YouTube video created specifically to focus entirely on promoting the brand'
    }),
    'Integrated video': i18n.t('orderDetail.orderTypeDescription.integratedVideo', {
      defaultValue:
        'A YouTube video that seamlessly incorporates brand promotion within your regular content'
    }),
    Reels: i18n.t('orderDetail.orderTypeDescription.reels', {
      defaultValue:
        'A short Instagram video created to exclusively promote a brand'
    }),
    'Carousel post': i18n.t('orderDetail.orderTypeDescription.carouselPost', {
      defaultValue:
        'A single Instagram post featuring multiple brand photos or videos that users can swipe through'
    }),
    'Tiktok video': i18n.t('orderDetail.orderTypeDescription.tiktokVideo', {
      defaultValue:
        'Exclusive TikTok video custom-made specifically for the brand.'
    }),
    [LinkedInContentTypeLabel[LinkedInContentType.VIDEO]]: i18n.t(
      'orderDetail.orderTypeDescription.linkedinVideoPost',
      {
        defaultValue:
          'A professional video post where you speak about or demonstrate the brand — such as use cases, expert opinions, or testimonials.'
      }
    ),
    [LinkedInContentTypeLabel[LinkedInContentType.IMAGE_TEXT]]: i18n.t(
      'orderDetail.orderTypeDescription.linkedinImagePost',
      {
        defaultValue:
          'A carousel post featuring branded visuals, infographics, or professional photos'
      }
    )
  };
  if (key === 'Post' && platform === AdsPlatform.Twitter.toLowerCase()) {
    return i18n.t('orderDetail.orderTypeDescription.twitterPost', {
      defaultValue: 'Exclusive X post custom-made specifically for the brand.'
    });
  }
  return map?.[key] || '';
};
